import React from 'react';

import Layout from '../components/Layout';

class Reports extends React.Component {

    render(){
        return(
            <Layout>
                <h1>Reports</h1>
            </Layout>
        );
    }
}

export default Reports;